const strings = {
  // Layout.js
  layout: {
    pageTitles: {
      home: "Electronic Document Management System",
      dataEntryForm: "Data Entry Form",
      library: "Environmental Document Library",
      database: "Environmental Document Database"
    },
    menuItems: {
      home: "Home",
      dataEntryForm: "Data Entry Form",
      library: "Library",
      database: "Database"
    },
    externalLinks: {
      portWebsite: "Port of Oakland Website",
      portWideEDMS: "Port-Wide EDMS SharePoint",
      validValues: "Valid Values",
      abbreviations: "Abbreviations"
    }
  },

  // Home.js
  home: {
    welcome: "Welcome to Port of Oakland EDMS",
    subtitle: "Electronic Document Management System",
    stats: {
      totalLibraryDocuments: "Total Library Documents",
      totalDatabaseRecords: "Total Database Records",
      loadingNote: "Note: Due to Microsoft API limitations, retrieving the total count for both Library documents and Database records requires pagination through all items. This process may take longer for large collections."
    }
  },

  // SignIn.js
  signIn: {
    welcome: "Welcome",
    signInPrompt: "Please sign in to access the Port of Oakland EDMS",
    signInButton: "Sign In with TRC SSO",
    permissionsMessage: "If a popup appears as shown in the image below, please click 'Accept' to grant the necessary permissions for system access."
  },

  // SiteAccessCheck.js
  siteAccess: {
    accessRequired: "Access Required",
    noAccessMessage: "You have successfully logged in, but you do not have access to the required SharePoint site.",
    contactAdmin: "Please contact the administrator of the Port-Wide Environmental Document Management System SharePoint site to request access."
  },

  // Data Entry Form
  form: {
    pdfUpload: {
      dragDropText: "Drag and drop your PDF file here, or click to browse"
    },
    fields: {
      docId: {
        label: "Document ID",
        placeholder: "Enter document ID"
      },
      title: {
        label: "Title",
        placeholder: "Enter document title"
      },
      siteName: {
        label: "Site Name",
        placeholder: "Select site name"
      },
      building: {
        label: "Building",
        placeholder: "Enter building name/number"
      },
      portArea: {
        label: "Port Area",
        placeholder: "Enter port area"
      },
      revenueDivision: {
        label: "Revenue Division",
        placeholder: "Select revenue division"
      }
    },
    sections: {
      locationDetails: "Location Details",
      classification: "Classification"
    }
  },
  // FormContent.js
  // DocIdField.js
  // Database.jsx
  database: {
    pageHeader: {
      title: "View and manage database records",
      externalLink: "https://trccompanies.sharepoint.com/sites/CS-P3/Port-of-Oakland/Lists/EMDS%20Library/AllItems.aspx?viewpath=%2Fsites%2FCS%2DP3%2FPort%2Dof%2DOakland%2FLists%2FEMDS%20Library%2FAllItems%2Easpx"
    },
    search: {
      placeholder: "Search by Document ID, Title, Category, Port Area, Division, or Site Name"
    },
    table: {
      headers: {
        docId: "Document ID",
        title: "Title",
        date: "Date",
        category: "Category",
        portArea: "Port Area",
        division: "Division",
        fileFormat: "File Format",
        siteName: "Site Name",
        created: "Created",
        modified: "Modified",
        actions: "Actions"
      },
      noRecords: "No records found"
    }
  },

  // Library.jsx
  library: {
    pageHeader: {
      title: "Access and manage your document library",
      externalLink: "https://trccompanies.sharepoint.com/sites/CS-P3/Port-of-Oakland/Environmental%20Document%20Bibliography/Forms/Test.aspx"
    },
    search: {
      placeholder: "Search documents"
    },
    table: {
      headers: {
        fileName: "File Name",
        type: "Type",
        created: "Created",
        modified: "Modified",
        actions: "Actions"
      },
      noDocuments: "No documents found",
      defaultType: "Document"
    }
  },

  // Common/others
  common: {
    na: "N/A",
    loading: "Loading...",
    error: "Error"
  }
};

export default strings; 